export default "/images/52f9aaff1a2ded443e284a50710d8320.png";